// extracted by mini-css-extract-plugin
export default {"wrapper":"List_wrapper__7De2s","header":"List_header__ONo13","users":"List_users__mKJbA","scrollButton":"List_scrollButton__Iz8Qz"};